import React from 'react'
import './CreateAPost.scss';
import theme from '../../shared/Theme/Theme';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const userStyles = makeStyles(theme => ({
    postButton: {
        borderRadius: "1rem",
        textTransform:"none",
        width:"80px",
        height:"35px",
        color:"white",
        backgroundColor:"#072E4F",
        "&:hover": {
            backgroundColor:"#0d3b61",
        }
    }
}))

function CreateAPost() {

    const classes = userStyles();

    return (
        <div>
            <div className="create-post-container">
                <Button disableFocusRipple disableRipple  className={classes.postButton}>
                    Post
                </Button>
            </div>
        </div>
    )
}

export default CreateAPost
